import React from "react";
import { makeStyles } from "@mui/styles";
import { Grid } from "@mui/material";

export function htmlTerms() {
  return {
    __html: `<main id="main" class="">
	<div id="content" role="main" class="content-area">
	   <div class="banner has-hover" id="banner-475169896">
		  <div class="banner-inner fill">
			 <div class="banner-bg fill">
				<div class="bg fill bg-fill  bg-loaded"></div>
			 </div>
			 <div class="banner-layers container">
				<div class="fill banner-link"></div>
				<div id="text-box-1226200022" class="text-box banner-layer x5 md-x5 lg-x5 y95 md-y50 lg-y50 res-text">
				   <div class="text box-shadow-1">
					  <div class="text-inner text-left">
						 <h2 class="lead">FAQs</h2>
					  </div>
				   </div>
				   <style>#text-box-1226200022 .text {
					  font-size: 100%;
					  }
					  #text-box-1226200022 .text-inner {
					  padding: 30px 30px 30px 30px;
					  }
					  #text-box-1226200022 {
					  width: 90%;
					  }
					  @media (min-width:550px) {
					  #text-box-1226200022 {
					  width: 44%;
					  }
					  }
				   </style>
				</div>
			 </div>
		  </div>
		  <style>
			 #banner-475169896 .bg.bg-loaded {
			 background-image: url(https://knowledge-pillars.com/wp-content/uploads/2020/05/bigstock-People-Asking-Questions-Around-358806586.jpg);
			 }
			 #banner-475169896 .bg {
			 background-position: 62% 60%;
			 }
		  </style>
	   </div>
	   <div class="row" id="row-2088496559">
		  <div id="col-74835959" class="col small-12 large-12">
			 <div class="col-inner">
				<ul>
				   <li>
					  <h4>What’s a certification?</h4>
					  <ul>
						 <li>a certification is an official document, or digital document, attesting the status of a certain achievement. In the IT learning industries, this can come in the form of a digital certificate and often a hard copy is also sent.</li>
					  </ul>
				   </li>
				   <li>
					  <h4>Are certifications all the same?</h4>
					  <ul>
						 <li>no, certifications have value if they are coming from a recognised body and are accredited by endorsements, credentials or badge.</li>
					  </ul>
				   </li>
				   <li>
					  <h4>What are credentials?</h4>
					  <ul>
						 <li>credentials are qualification of someone’s background, that make him suitable for some specific job.&nbsp;</li>
					  </ul>
				   </li>
				   <li>
					  <h4>Do I always need to certify? Aren’t my skills enough?</h4>
					  <ul>
						 <li>certifications prove your skills, allowing an employer to make a faster decision to hire you, without running specific assessments to test your knowledge. For the same reason, certification add value to your professional profile, increasing your chances of getting a better job with a higher salary.</li>
					  </ul>
				   </li>
				   <li>
					  <h4>What is a badge?</h4>
					  <ul>
						 <li>
							<p>a badge, in learning industries, is a digital stamp provided by an independent, that guarantees accreditation to a certificate. The badge is generally digital and can be shown on personal curriculum or on social media profiles. Acclaim is the most known digital badge.</p>
						 </li>
					  </ul>
				   </li>
				   <li>
					  <h4>What is a practice test?</h4>
					  <ul>
						 <li>a practice test is an assessment that prepares students to take a certain exam, providing with pretty much the same questions of the exam. In many cases, it simulates the exact exam environment, providing students with the same feeling of taking the actual exam.</li>
					  </ul>
				   </li>
				   <li>
					  <h4>How can I buy your products?</h4>
					  <ul>
						 <li>Knowledge Pillars sells to different categories of customers. Whether you are a student or a school, organization, university you need to register on our page and access our webshop. To register, left click on the login icon on the right top of the www.knowledge-pillars.com and a registration form will pop-up.</li>
					  </ul>
				   </li>
				</ul>
			 </div>
		  </div>
	   </div>
	</div>
 </main>`
  };
}

const useStyles = makeStyles({
  root: {
    color: "#424242",
    padding: "1rem 0 2rem"
  }
});

const FAQs = () => {
  const classes = useStyles();
  return (
    <>
      <Grid container direction="column" justifyContent="center" alignItems="center">
        <Grid
          container
          item
          xs={10}
          md={7}
          className={classes.root}
          dangerouslySetInnerHTML={htmlTerms()}
        />
      </Grid>
    </>
  );
};

export default FAQs;
